import React from "react";

// Replaces the Chakra Spinner (and the two hand-rolled ones in Login/Register)
// so loading looks the same everywhere.
const SIZES = { sm: "h-4 w-4 border-2", md: "h-8 w-8 border-[3px]", lg: "h-12 w-12 border-4" };

const Spinner = ({ size = "md", className = "" }) => (
  <span
    role="status"
    aria-label="Loading"
    className={`inline-block animate-spin rounded-full border-border border-t-primary ${
      SIZES[size] ?? SIZES.md
    } ${className}`}
  />
);

export default Spinner;
